export function SET_REDIRECT({ commit }, [redirect]) {
    commit('SAVE_REDIRECT', [redirect])
}

export function SET_TOKEN({ commit }, [token]) {
    commit('SAVE_TOKEN', [token])
}
